// TODO rename enum items
export enum DeliveryProgressStepType {
  Invoice = 'Invoice',
  Logistics = 'Logistics',
  Delivery = 'Delivery',
  Office = 'Office',
  Pickup = 'Pickup',
  Complete = 'Complete',
}
